(function() {
  'use strict';

  function scrollToSection(id) {
    var el = document.getElementById(id);
    if (!el) return false;
    var header = document.querySelector('.section-header, header.section-header, sticky-header');
    var headerH = header ? header.offsetHeight : 0;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerH - 20;
    window.scrollTo({ top: top, behavior: 'smooth' });
    return true;
  }

  function initFooterLinks() {
    var links = document.querySelectorAll('a.fql[data-id]');
    links.forEach(function(a) {
      a.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var id = this.getAttribute('data-id');
        if (!id) return;
        var isHome = window.location.pathname === '/' || window.location.pathname === '';
        if (isHome) {
          scrollToSection(id);
        } else {
          // Store target in sessionStorage and redirect to home
          sessionStorage.setItem('fql_target', id);
          window.location.href = '/';
        }
      });
    });
  }

  // Handle hash on page load (coming from another page)
  function handleHashOnLoad() {
    var id = sessionStorage.getItem('fql_target');
    if (!id) return;
    sessionStorage.removeItem('fql_target');
    var attempts = 0;
    var interval = setInterval(function() {
      attempts++;
      if (scrollToSection(id) || attempts > 15) {
        clearInterval(interval);
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterLinks);
  } else {
    initFooterLinks();
  }

  window.addEventListener('load', handleHashOnLoad);
})();
